import { render, staticRenderFns } from "./ChangePalletStatus.vue?vue&type=template&id=7203035c&"
import script from "./ChangePalletStatus.vue?vue&type=script&lang=js&"
export * from "./ChangePalletStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangePalletStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports